import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
});

/* ================= GET ALL QUIZ ================= */

export const fetchOnlyQuizzes = createAsyncThunk(
  "onlyQuiz/fetchOnlyQuizzes",
  async ({ search = "", page = 1, limit = 10 }, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/master-quiz/all?search=${search}&page=${page}&limit=${limit}`,
        { headers: getHeaders() }
      );

      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

/* ================= GET QUIZ BY ID ================= */

export const fetchOnlyQuizById = createAsyncThunk(
  "onlyQuiz/fetchOnlyQuizById",
  async (id, thunkAPI) => {
    try {
      const res = await axios.get(`${BASE_URL}/master-quiz/${id}`, {
        headers: getHeaders(),
      });

      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

/* ================= ADD QUIZ ================= */

export const addOnlyQuiz = createAsyncThunk(
  "onlyQuiz/addOnlyQuiz",
  async (data, thunkAPI) => {
    try {
      const payload = {
        name: data.name,
        name_dk: data.name_dk,
        question_ids: data.question_ids,
      };

      const res = await axios.post(`${BASE_URL}/master-quiz`, payload, {
        headers: getHeaders(),
      });

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

/* ================= UPDATE QUIZ ================= */

export const updateOnlyQuiz = createAsyncThunk(
  "onlyQuiz/updateOnlyQuiz",
  async ({ id, data }, thunkAPI) => {
    try {
      const payload = {
        quiz_id: id,
        name: data.name,
        name_dk: data.name_dk,
        question_ids: data.question_ids,
      };

      const res = await axios.put(`${BASE_URL}/master-quiz`, payload, {
        headers: getHeaders(),
      });

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

/* ================= DELETE QUIZ ================= */

export const deleteOnlyQuiz = createAsyncThunk(
  "onlyQuiz/deleteOnlyQuiz",
  async (id, thunkAPI) => {
    try {
      await axios.delete(`${BASE_URL}/master-quiz/${id}`, {
        headers: getHeaders(),
      });

      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const fetchQuizList = createAsyncThunk(
  "onlyQuiz/fetchQuizList",
  async (thunkAPI) => {
    try {
      const res = await axios.get(`${BASE_URL}/master-quiz/list`, {
        headers: getHeaders(),
      });

      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const onlyQuizSlice = createSlice({
  name: "onlyQuiz",

  initialState: {
    onlyQuizzes: [],
    selectedOnlyQuiz: null,
    page: 1,
    limit: 10,
    total: 0,

    loading: false,
    singleLoading: false,
    saving: false,
    deleting: false,

    error: null,

    quizzesList: [],
  },

  reducers: {
    clearSelectedOnlyQuiz: (state) => {
      state.selectedOnlyQuiz = null;
    },
  },

  extraReducers: (builder) => {
    /* ===== GET ALL QUIZ ===== */
    builder
      .addCase(fetchOnlyQuizzes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOnlyQuizzes.fulfilled, (state, action) => {
        state.loading = false;
        state.onlyQuizzes = action.payload.quiz || [];
        state.page = action.payload.page;
        state.limit = action.payload.limit;
        state.total = action.payload.total;
      })
      .addCase(fetchOnlyQuizzes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    /* ===== GET QUIZ BY ID ===== */
    builder
      .addCase(fetchOnlyQuizById.pending, (state) => {
        state.singleLoading = true;
      })
      .addCase(fetchOnlyQuizById.fulfilled, (state, action) => {
        state.singleLoading = false;
        state.selectedOnlyQuiz = action.payload;
      })
      .addCase(fetchOnlyQuizById.rejected, (state) => {
        state.singleLoading = false;
      });

    /* ===== ADD QUIZ ===== */
    builder
      .addCase(addOnlyQuiz.pending, (state) => {
        state.saving = true;
      })
      .addCase(addOnlyQuiz.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(addOnlyQuiz.rejected, (state) => {
        state.saving = false;
      });

    /* ===== UPDATE QUIZ ===== */
    builder
      .addCase(updateOnlyQuiz.pending, (state) => {
        state.saving = true;
      })
      .addCase(updateOnlyQuiz.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(updateOnlyQuiz.rejected, (state) => {
        state.saving = false;
      });

    /* ===== DELETE QUIZ ===== */
    builder
      .addCase(deleteOnlyQuiz.pending, (state) => {
        state.deleting = true;
      })
      .addCase(deleteOnlyQuiz.fulfilled, (state, action) => {
        state.deleting = false;
        state.onlyQuizzes = state.onlyQuizzes.filter(
          (quiz) => quiz.id !== action.payload
        );
      })
      .addCase(deleteOnlyQuiz.rejected, (state) => {
        state.deleting = false;
      });

    builder
      .addCase(fetchQuizList.pending, (state) => {
        state.singleLoading = true;
      })
      .addCase(fetchQuizList.fulfilled, (state, action) => {
        state.singleLoading = false;
        state.quizzesList = action.payload;
      })
      .addCase(fetchQuizList.rejected, (state) => {
        state.singleLoading = false;
      });
  },
});

export const { clearSelectedOnlyQuiz } = onlyQuizSlice.actions;

export default onlyQuizSlice.reducer;
